<template>
    <v-dialog
        :value="isOpen"
        max-width="1100px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <ComplaintReturnEditDialog
            :is-open="complaintReturnEditDialog"
            :complaint-return-number="currentComplaintReturnNumber"
            :current-complaint="currentComplaintInEdit"
            @on-confirm="updateReturnNumberInComplaint"
            @on-close="closeComplaintReturnEditDialog"
        />
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja listów przewozowych
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    v-model="selectedComplaintReturnNumber"
                    :headers="complaintReturnNumberHeaders"
                    :items="notReturned"
                    :mobile-breakpoint="0"
                    :show-select="isWarehouseUser"
                    disable-pagination
                    hide-default-footer
                    name="complaintReturnNumberData"
                >
                    <template #item.plannedReturnDate="{item}">
                        {{ formatDate(item.plannedReturnDate, withTime = false) }}
                    </template>
                    <template #item.packageNumber="{item}">
                        {{ item.packageNumber }}
                        <v-btn
                            v-if="isShopUser"
                            text
                            icon
                            small
                            color="primary"
                            @click="showComplaintReturnEditDialog(item)"
                        >
                            <v-icon small>
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </template>
                    <template #item.createdAt="{item}">
                        {{ formatDate(item.createdAt) }}
                    </template>
                    <template slot="no-results" :value="true">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="isShopUser || isWarehouseUser"
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveComplaintReturnNumber()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import ComplaintReturnEditDialog from './ComplaintReturnEditDialog'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { findIndex, orderBy } from 'lodash'


export default {
    name: 'ComplaintReturnListDialog',
    components: {
        ComplaintReturnEditDialog
    },
    mixins: [
        dateFormatter, tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        complaintStatusHistory: {
            type: Array,
            default: null
        },
        currentComplaint: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            complaint: {},
            confirmReturnToStorageDialog: false,
            currentComplaintReturnNumber: null,
            selectedComplaintReturnNumber: [],
            complaintReturnEditDialog: false,
            notReturned: [],
            currentComplaintInEdit: {},
            complaintReturnNumberHeaders: [
                {
                    text: 'Planowana data zwrotu',
                    align: 'center',
                    sortable: false,
                    value: 'plannedReturnDate',

                },
                {
                    text: 'Numer listu przewozowego',
                    value: 'packageNumber',
                    sortable: false,
                    align: 'center',

                },
                {
                    text: 'Data utworzenia',
                    align: 'center',
                    sortable: false,
                    value: 'createdAt'
                }
            ],
        }
    },
    computed: {
        isShopUser() {
            return hasUserPermission('complaints_shop_update')
        },
        isWarehouseUser() {
            return hasUserPermission('complaints_warehouse_update')
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.complaint = JSON.parse(JSON.stringify(this.currentComplaint))
                this.notReturned = orderBy(this.complaint.complaintReturnNumber.filter(item => !item.returned), 'id', 'desc')
            } else {
                setTimeout(() => {
                    this.complaint = {}
                    this.currentComplaintReturnNumber = null,
                    this.selectedComplaintReturnNumber = [],
                    this.notReturned = []
                }, 500)
            }
        }
    },
    methods: {
        showComplaintReturnEditDialog(complaintReturnNumber) {
            this.currentComplaintReturnNumber = complaintReturnNumber
            this.currentComplaintInEdit = JSON.parse(JSON.stringify(this.complaint))
            this.complaintReturnEditDialog = true
        },
        closeComplaintReturnEditDialog() {
            this.complaintReturnEditDialog = false
            this.currentComplaintReturnNumber = {}
            this.currentComplaintInEdit = {}
        },
        updateReturnNumberInComplaint(payload) {
            this.complaint = payload
            this.notReturned = orderBy(payload.complaintReturnNumber.filter(item => !item.returned), 'id', 'desc')
        },
        saveComplaintReturnNumber() {
            if (this.selectedComplaintReturnNumber.length > 0) {
                this.selectedComplaintReturnNumber.forEach(item => {
                    item.returned = true
                    const index = findIndex(this.complaint.complaintReturnNumber, { 'id': item.id })

                    this.complaint.complaintReturnNumber.splice(index, 1, item)
                })
            }
            this.$emit('on-confirm', this.complaint)
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>